import { cn } from '@/lib/utils';

/**
 * Ta sama tabela stoi w kroku W1 (operator) i w karcie klienta w kroku W3 —
 * różnią się wyłącznie marginesem bocznym i tym, jaką rolę osoby pokazują
 * („Uczestnik · 6 lat” u operatora, „uczestniczka” u klienta).
 */
export type ChangeSummaryTableVariant = 'operator' | 'client';

/**
 * Kolumny w proporcjach, nie w pikselach: ta sama tabela dostaje 880 px w karcie
 * klienta i całą szerokość treści u operatora, a stałe szerokości zjadały przy
 * węższym kontenerze kolumnę pozycji, zamiast oddać po równo.
 *
 * Wiersz ma trzy postacie. Powyżej 700 px cztery kolumny. Między 440 a 700 px
 * dwie: nazwa i kwota w pierwszej linii, nowa wartość pod nazwą — dopóki z prawej
 * jest miejsce, nie ma po co układać wszystkiego w pion. Poniżej 440 px jedna
 * kolumna. Próg mierzy **kontener**, nie okno: tabela stoi w kolumnie treści,
 * która obok panelu bocznego bywa wąska także na dużym ekranie (patrz
 * `billGrid.ts`, ta sama pułapka).
 */
const gridClass =
  'grid grid-cols-1 gap-y-0.5 @min-[440px]:grid-cols-[1fr_auto] @min-[440px]:gap-x-4 @min-[700px]:grid-cols-[1.5fr_1fr_1fr_.75fr] @min-[700px]:gap-x-0 @min-[700px]:gap-y-0';

const paddingClass: Record<ChangeSummaryTableVariant, string> = {
  operator: 'px-4 @min-[700px]:px-7',
  client: 'px-4 @min-[700px]:px-[26px]',
};

/** Siatka wiersza. Nagłówek i wszystkie wiersze biorą ją stąd. */
export const summaryRowClass = (variant: ChangeSummaryTableVariant): string =>
  cn(gridClass, paddingClass[variant]);

/** Same marginesy boczne — dla pasków spoza siatki: osoby i pustego stanu. */
export const summaryGutterClass = (
  variant: ChangeSummaryTableVariant,
): string => paddingClass[variant];

/**
 * Wcięcie treści wiersza pod nazwisko z paska osoby: awatar (28 px) i odstęp
 * (10 px). Przynależność wiersza widać po samym układzie, bez tła i znaczników.
 */
export const summaryIndentClass = 'pl-[38px]';
